import * as $ from 'jquery';
import { apiBaseUrlAdmin, apiBaseUrlUser } from '../../../constants/url.constant';
import { CustomerFilterModel } from '../models/CustomerModel';
import { DefaultService } from '../../common/services/DefaultService';

export class CustomerAdminService extends DefaultService {
    private baseUrl = `${apiBaseUrlAdmin}/customer`;

    public RouteSearch = () => `${this.baseUrl}/search`;
    public search(model: CustomerFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteSearch(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteGetCountByTypes = () => `${this.baseUrl}/getCountByTypes`;
    public getCountByTypes(model: CustomerFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteGetCountByTypes(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }
}

export class CustomerService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/customer`;

    public RouteGet = () => `${this.baseUrl}/get`;
    public get(): JQueryPromise<any> {
        return $.ajax(this.RouteGet(), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteCreatePicture = () => `${this.baseUrl}/createPicture`;
}